import TextoApresentacao from 'components/TextoApresentacao';
import { bucketS3, caminhoAnexosGestaoPaginaBanner } from 'constants/EnvironmentData';
import {
    BannerContainerStyle,
    BannerStyle,
    ContentContainer,
    TitleStyle,
    ContentStyle,
    ButtonsContainer,
    Layer,
    TextContainer,
    BannerSection,
    SplitContainer,
    YellowButton,
    ButtonsBox,
    ImgLateral,
    LeftContainer,
    ImgMobile,
} from 'pages/home/components/banner/BannerContainer.styled';

import React, { useState } from 'react';
import Styled from './Banner.styled';
import BannerModel from 'models/generic-components/SecaoBanner';
import GenericComponentsUtils from '../generic-components.utils';
import { useHistory } from 'react-router';
import useLogged from 'hooks/useLogged';

export interface IBanner {
    dados: BannerModel;
}

// A EXPERIÊNCIA DIGITAL DE FORMAÇÃO DO INTITUTO AYRTON SENNA

const Banner = ({ dados }: IBanner) => {
    const history = useHistory();
    const { authenticated } = useLogged();

    const getS3BaseUrl = (): string => {
        return bucketS3() + caminhoAnexosGestaoPaginaBanner();
    };

    const acessar = (location: string) => {
        GenericComponentsUtils.gotoLink(location, history, authenticated, dados);
    };

    return (
        <>
            {dados && (
                <>
                    {!dados.paginaLateral ? (
                        <BannerContainerStyle id="inicio">
                            <BannerStyle svgSource={getS3BaseUrl() + dados.filePath}>
                                <Layer />
                                <ContentContainer>
                                    <TextContainer>
                                        <TitleStyle>{dados.titulo}</TitleStyle>
                                        <ContentStyle>{dados.descricao}</ContentStyle>
                                    </TextContainer>

                                    <ButtonsContainer>
                                        <Styled.Button
                                            onClick={() => {
                                                acessar(dados.link);
                                            }}
                                        >
                                            {dados.textoBotaoA}
                                        </Styled.Button>
                                    </ButtonsContainer>
                                </ContentContainer>
                            </BannerStyle>
                        </BannerContainerStyle>
                    ) : (
                        <BannerContainerStyle id="inicio">
                            <BannerSection>
                                <SplitContainer>
                                    <LeftContainer>
                                        <ImgMobile src={getS3BaseUrl() + dados.filePath} />

                                        <TextoApresentacao
                                            style={{
                                                container: { maxWidth: '650px' },
                                                titulo: { fontSize: 'clamp(24px, 6.5vw, 36px)' },
                                                subtitulo: { fontSize: '16px', color: 'black' },
                                            }}
                                            tipo=""
                                            titulo={dados.titulo ?? ''}
                                            subtitulo={dados.descricao ?? ''}
                                        >
                                            <ButtonsBox>
                                                <YellowButton
                                                    onClick={() => {
                                                        acessar(dados.link);
                                                    }}
                                                >
                                                    {dados.textoBotaoA}
                                                </YellowButton>
                                            </ButtonsBox>
                                        </TextoApresentacao>
                                    </LeftContainer>
                                    <ImgLateral src={getS3BaseUrl() + dados.filePath} />
                                </SplitContainer>
                            </BannerSection>
                        </BannerContainerStyle>
                    )}
                </>
            )}
        </>
    );
};

export default Banner;
